import React from "react";
import useThemeColors from "../organization/portal/useThemeColors";
import InitialsAvatar from "../../util/name_initial";

export default function GameMatchboard({
    visitorTeam,
    homeTeam,
    visitorScore,
    homeScore,
    visitorLabel,
    homeLabel,
    penaltiesHome,
    penaltiesVisitor,
    penaltyLabel,
}) {
    const colors = useThemeColors();

    return (
        <div className="kbola-matchboard">
            <div className="kbola-matchboardTop">
                <div className="kbola-matchTeamCard is-left">
                    <div className="kbola-matchTeamIdentity">
                        {visitorTeam?.logoUrl ? (
                            <img src={visitorTeam.logoUrl} alt={visitorTeam.name} className="kbola-soccerTeamLogo"/>
                        ) : (
                            <InitialsAvatar name={visitorTeam?.name} size={44} backgroundColor={colors.secondary} textColor={colors.textOnSecondary}/>
                        )}
                        <div className="kbola-matchTeamText">
                            <div className="kbola-matchTeamSub">{visitorLabel}</div>
                            <div className="kbola-matchTeamName">{visitorTeam?.name || visitorLabel}</div>
                        </div>
                    </div>
                </div>

                <div className="kbola-matchCenterBadge">
                    <div className="kbola-matchCenterScore is-left">{visitorScore ?? 0}</div>
                    <div className="kbola-matchCenterTop">@</div>
                    <div className="kbola-matchCenterScore is-right">{homeScore ?? 0}</div>
                    {penaltiesHome != null && penaltiesVisitor != null && (
                        <div className="kbola-matchCenterPenalties">
                            {penaltiesVisitor}–{penaltiesHome} {penaltyLabel}
                        </div>
                    )}
                </div>

                <div className="kbola-matchTeamCard is-right">
                    <div className="kbola-matchTeamIdentity is-right">
                        <div className="kbola-matchTeamText is-right">
                            <div className="kbola-matchTeamSub">{homeLabel}</div>
                            <div className="kbola-matchTeamName">{homeTeam?.name || homeLabel}</div>
                        </div>
                        {homeTeam?.logoUrl ? (
                            <img src={homeTeam.logoUrl} alt={homeTeam.name} className="kbola-soccerTeamLogo"/>
                        ) : (
                            <InitialsAvatar name={homeTeam?.name} size={44} backgroundColor={colors.primary} textColor={colors.textOnPrimary}/>
                        )}
                    </div>
                </div>
            </div>
            <style>{`
                .kbola-matchboard { display: flex; flex-direction: column; gap: 16px; margin-bottom: 16px; }
                .kbola-matchboardTop { display: grid; grid-template-columns: 1fr auto 1fr; gap: 14px; align-items: center; }
                .kbola-matchTeamCard { padding: 14px; border: 1px solid rgba(0,0,0,.07); border-radius: 20px; background: rgba(255,255,255,.9); box-shadow: 0 10px 24px rgba(0,0,0,.05); }
                .kbola-matchTeamIdentity { display: flex; align-items: center; min-width: 0; gap: 12px; }
                .kbola-matchTeamIdentity.is-right { justify-content: flex-end; }
                .kbola-matchTeamText { min-width: 0; }
                .kbola-matchTeamText.is-right { text-align: right; }
                .kbola-matchTeamSub { margin-bottom: 2px; color: rgba(20,21,26,.54); font-size: 11px; font-weight: 900; letter-spacing: .06em; text-transform: uppercase; }
                .kbola-matchTeamName { overflow: hidden; color: rgba(20,21,26,.95); font-size: 16px; font-weight: 900; text-overflow: ellipsis; white-space: nowrap; }
                .kbola-matchCenterBadge { min-width: 120px; min-height: 72px; padding: 10px; border: 1px solid rgba(0,0,0,.07); border-radius: 24px; display: flex; flex-wrap: wrap; align-items: center; justify-content: center; gap: 8px; background: linear-gradient(180deg,rgba(255,255,255,.95),rgba(247,248,250,.95)); box-shadow: 0 12px 28px rgba(0,0,0,.06); }
                .kbola-matchCenterScore { min-width: 32px; height: 32px; border-radius: 50%; display: flex; align-items: center; justify-content: center; color: #fff; font-size: 16px; font-weight: 900; line-height: 1; }
                .kbola-matchCenterScore.is-left { background: ${colors.secondary}; }
                .kbola-matchCenterScore.is-right { background: ${colors.primary}; }
                .kbola-matchCenterTop { color: rgba(20,21,26,.88); font-size: 20px; font-weight: 900; line-height: 1; }
                .kbola-matchCenterPenalties { flex-basis: 100%; color: rgba(20,21,26,.56); font-size: 10px; font-weight: 900; text-align: center; text-transform: uppercase; }
                .kbola-soccerTeamLogo { width: 44px; height: 44px; flex-shrink: 0; padding: 2px; border: 1px solid rgba(0,0,0,.08); border-radius: 12px; object-fit: contain; background: #fff; }
                @media (max-width: 700px) { .kbola-matchboardTop { grid-template-columns: 1fr; } .kbola-matchTeamCard.is-left, .kbola-matchTeamCard.is-right { text-align: center; } .kbola-matchTeamIdentity, .kbola-matchTeamIdentity.is-right { justify-content: center; } .kbola-matchTeamText.is-right { text-align: center; } .kbola-matchCenterBadge { justify-self: center; } }
            `}</style>
        </div>
    );
}
